import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

const ls = new SecureLS({
  encodingType: "des",
  isCompression: false,
  encryptionSecret: "Gtye682ThF8",
});

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    //createPersistedState({ storage: window.sessionStorage, key: '4GJGH' })
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
      key: "4GJ0GH",
    }),
  ],
  state: {
    pageTitle: "",
    isHeadShotOpen: false,
    imgHeadShot: "",
    isIdOpen: false,
    imgId: "",
    isIdBackOpen: false,
    imgIdBack: "",
    userCode: "",
    userName: "",
    userType: "",
    isLimitOver: false,
    Deadline: "",
    Token: "",
    eventInfo: {
      EventId: "",
      EventName: "",
      EventUrl: "",
      EventDate: "",
      AccredMgrName: "",
      AccredMgrEmail: "",
      AccredMgrContact: "",
      VendorId: "",
      VendorName: "",
      VendorEmail: "",
      VenueId: "",
      VenueName: "",
      VenueType: "",
      StadiumName: "",
      TemplateId: "",
      IsImport: "N",
      VendorLink: false,
      LinkId:''
    },
    appInfo: { AppMode: "New", AppId: "" },
    activeZones:""
  },
  mutations: {
    resetApplication(state) {
      state.appInfo.AppMode = "New";
      state.appInfo.AppId = "";
      state.imgHeadShot = "";
      state.imgId = "";
      state.imgIdBack = "";
    },
    setAppInfo(state, payload) {
      state.appInfo.AppMode = payload.AppMode;
      state.appInfo.AppId = payload.AppId;
    },
    setLimitOver(state, payload) {
      state.isLimitOver = payload;
    },
    setDeadline(state, payload) {
      state.Deadline = payload;
    },
    setEventInfo(state, payload) {
      state.eventInfo.EventId = payload.event_id;
      state.eventInfo.EventName = payload.event_name;
      state.eventInfo.EventUrl = payload.event_url;
      state.eventInfo.EventDate = payload.event_date;
      state.eventInfo.AccredMgrName = payload.contact_name;
      state.eventInfo.AccredMgrEmail = payload.contact_email;
      state.eventInfo.AccredMgrContact = payload.contact_no;
      state.eventInfo.VendorId = payload.vendor_id;
      state.eventInfo.VendorName = payload.company_name;
      state.eventInfo.VendorEmail = payload.vendor_email;
      state.eventInfo.VenueId = payload.venue_id;
      state.eventInfo.VenueName = payload.venue_name;
      state.eventInfo.VenueType = payload.venue_type;
      state.eventInfo.StadiumName = payload.stadium_name;
      state.eventInfo.TemplateId = payload.template_id;
      state.eventInfo.IsImport = payload.isImport;
      state.eventInfo.ImportEventId = payload.import_from_event;
      state.eventInfo.ImportEventName = payload.import_from_event_name;
      state.eventInfo.VendorLink = payload.vendor_link;
      state.eventInfo.LinkId = '';
      state.Token = payload.token;
      sessionStorage.setItem("token", payload.token);
      state.Deadline = payload.deadline;
    },
    
    setEventInfoLink(state, payload) {
      state.eventInfo.EventId = payload.event_id;
      state.eventInfo.VenueId = payload.venue_id;
      state.eventInfo.VendorId = payload.vendor_id;
      state.eventInfo.TemplateId = payload.temp_id;
      state.eventInfo.LinkId = payload.link_id;
      state.eventInfo.EventUrl = payload.event_url;
      state.Token = payload.token;
      sessionStorage.setItem("token", payload.token);
      state.appInfo.AppMode = "New";
      state.Deadline = "open"
    },
    setPageTitle(state, payload) {
      state.pageTitle = payload;
    },
    setHeadshot(state, payload) {
      state.isHeadShotOpen = payload;
    },
    setHeadshotImg(state, payload) {
      state.imgHeadShot = payload;
    },
    setIdOpen(state, payload) {
      state.isIdOpen = payload;
    },
    setIdImg(state, payload) {
      state.imgId = payload;
    },
    setIdBackOpen(state, payload) {
      state.isIdBackOpen = payload;
    },
    setIdBackImg(state, payload) {
      state.imgIdBack = payload;
    },
    setUserName(state, payload) {
      state.userName = payload;
    },
    setUserType(state, payload) {
      state.userType = payload;
    },
    logout(state) {
      state.eventInfo.EventId = "";
      state.eventInfo.EventName = "";
      //state.eventInfo.EventUrl = "";
      state.eventInfo.EventDate = "";
      state.eventInfo.AccredMgrName = "";
      state.eventInfo.AccredMgrEmail = "";
      state.eventInfo.AccredMgrContact = "";
      state.eventInfo.VendorId = "";
      state.eventInfo.VendorName = "";
      state.eventInfo.VendorEmail = "";
      state.eventInfo.VenueId = "";
      state.eventInfo.VenueName = "";
      state.eventInfo.VenueType = "";
      state.eventInfo.StadiumName = "";
      state.eventInfo.TemplateId = "";
      state.eventInfo.LinkId = "";

      state.Token = "";
      state.Deadline = "";
      sessionStorage.setItem("token", "");
      sessionStorage.clear();
      localStorage.clear();
    },
    logoutAll() {
      localStorage.clear();
    },
    setActiveZones(state, payload) {
      state.activeZones = payload;
    },
  },
  actions: {
    // setEventInfo(context, payload) {
    // 	context.commit("setEventInfo", payload);
    // }
  },
  modules: {},
});
